import React, { Component } from 'react'
import { connect } from 'react-redux'
import { compose } from 'redux'

import { Container, PageTitle, PageSpinner, Spinner, PageHeader, DescriptionList, Link, H3 } from '../components/index'
import { selectIsRequestPending, requireLogin } from '../util/index'
import { selectADUserInfo, selectJiraUser } from '../auth/reducer'


import Avatar, { AvatarItem } from '@atlaskit/avatar'
import Lozenge from '@atlaskit/lozenge'
import DynamicForm from './request/forms/DynamicForm'
import DynamicView from './request/forms/DynamicView'
import CommentSection from './components/CommentSection'

import { getIssue, updateIssue, getRequestType, updateIssueData } from './actions'
import { selectRequestType, selectIssue, selectIssueError } from './reducer'

const dateOptions = { year: 'numeric', month: 'long', day: 'numeric', 'hour': '2-digit', 'minute': '2-digit', 'hour12': false }

class ViewRequestPage extends Component {

  constructor (props, ...args) {
    super(props, ...args),
    this.state = {        
        editing: false,        
    }
}

  componentWillMount () {                
    let { getIssue, issueKey, issue } = this.props    
    // if url has issue key then
    if (issueKey && !issue ) {
      // then get the specific Issue identified by that ID if that issue isn't already loaded to state
      getIssue(issueKey)        
    }    
  }

  handleUpdate = (values) => {
      let { updateIssue, issueKey } = this.props
      updateIssue(values, issueKey).catch(err => console.error(err)) 
      this.setState({editing: !this.state.editing})     
  }

  handleEditing = () => {        
    this.setState({editing: !this.state.editing})
  }
  
  handleCancel = () => {
    this.setState({editing: !this.state.editing})
  }


  render () {
    let {      
      issue,
      issueKey,      
      isIssuePending,
      isUpdatePending,
      issueError,
      JiraUser
    } = this.props
    if (issueError) return (
      <div>
        <PageTitle title="Issue not Found" />
        <PageHeader title="Issue Lookup Error" back={<Link to={'/'} className='page-title-back'>&lt; Home</Link>} />        
        <Container section>        
          <div className='status-inactive fs20-sm lh20-sm fs24-md lh24-md'>{issueError}</div>
        </Container>
      </div>
    )
    if ( (issueKey && isIssuePending) || !issue ) return <PageSpinner title='Looking Up Issue...'/>
    let assignee = issue.assignee ? issue.assignee : null
    let status = issue.status ? issue.status : {}
    let resolution = issue.resolution ? issue.resolution : 'Unresolved'
    let created = issue.created ? new Date(issue.created) : null
    let updated = issue.updated ? new Date(issue.updated) : null
    let issueLink = issue.issue_link ? issue.issue_link : null
    let issueKeyLink = JiraUser && issueLink ? <a href={issueLink} target="_blank" className="link">{issueKey}</a> : issueKey
    return (
      <div>
        <PageTitle title={issueKey} />  
        <PageHeader title={issueKeyLink} 
          back={<Link to={'/'} className='page-title-back'>&lt; Home</Link>}>
        
        </PageHeader>        
        <Container section>          
          <H3 className='pb5-sm'>Issue Details</H3>          
          {
            isUpdatePending ? <Spinner large></Spinner> :
            <div className='split-container fit-right'>
              <div className='split-container-right split-container-border-left border-left'>
                <DescriptionList hideEmpty items={{
                  'Status': <Lozenge appearance={status.appearance} isBold>{status.name}</Lozenge>,
                  'Assignee': <AvatarItem
                    avatar={<Avatar src={ assignee ? assignee.avatarUrls['32x32'] : null} size='large'/>}
                    key={ assignee ? assignee.emailAddress : null}
                    primaryText={assignee ? assignee.displayName : 'Unassigned'}
                    secondaryText={assignee ? assignee.emailAddress : null}
                    enableTextTruncate={true}
                    isActive={false}              
                  />,
                  'Resolution': <div>{resolution}</div>,
                  'Created': <div>{created.toLocaleDateString('en-US', dateOptions)}</div>,
                  'Updated': <div>{updated.toLocaleDateString('en-US', dateOptions)}</div>,                   
                }} />
              </div>
              <div className='split-container-left'>
                {
                  this.state.editing ?
                  <DynamicForm RequestType={issue.requestType}
                    isNew={false}
                    Issue={issue}
                    onSubmit={this.handleUpdate}                    
                    actionInProgress={isUpdatePending}
                    cancel={this.handleCancel}
                  />
                  : <DynamicView Issue={issue} editIssue={this.handleEditing} />
                }
              </div>
            </div>
          }
          
        </Container>
        <Container section>
          <H3 className='pb5-sm'>Comments</H3>
          {
            <CommentSection Issue={issue} />
          }
        </Container>
      </div>
    )
  }
}

export default compose(
  requireLogin('Request'),
  connect((state, ownProps) => {
  return {
    isUpdatePending: selectIsRequestPending(state, updateIssue),
    isIssuePending: selectIsRequestPending(state, getIssue),
    requestType: selectRequestType(state),    
    isRequestTypePending: selectIsRequestPending(state, getRequestType),    
    issueKey: ownProps.match.params.issueKey,
    issue: selectIssue(state),
    user: selectADUserInfo(state),
    JiraUser: selectJiraUser(state),
    issueError: selectIssueError(state),
  }
}, { getIssue, getRequestType, updateIssue, updateIssueData }))(ViewRequestPage)



// WEBPACK FOOTER //
// ./client/src/serviceDesk/ViewEditRequest.js